var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageOutsorced({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5H18V13.5H9V11.5ZM18 7.5H6V9.5H18V7.5ZM22 4.5V22.5L18 18.5H4C2.9 18.5 2 17.61 2 16.5V4.5C2 3.4 2.9 2.5 4 2.5H20C21.1 2.5 22 3.39 22 4.5ZM20 4.5H4V16.5H18.83L20 17.67V4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageOutsorced);
export default __webpack_public_path__ + "static/media/messageOutsorced.ee427c2f49b9d9a4911af514dea1f06b.svg";
export { ForwardRef as ReactComponent };